<template>
  <div class="app-navigation-drawer">
    <!--        <v-navigation-drawer app v-model="drawer" class="blue lighten-2" dark disable-resize-watcher>-->
    <!--            <v-list>-->
    <!--                <template v-for="(item, index) in items">-->
    <!--                    <v-list-tile :key="index">-->
    <!--                        <v-list-tile-content>-->
    <!--                            {{item.title}}-->
    <!--                        </v-list-tile-content>-->
    <!--                    </v-list-tile>-->
    <!--                    <v-divider :key="`divider-${index}`"></v-divider>-->
    <!--                </template>-->
    <!--            </v-list>-->
    <!--        </v-navigation-drawer>-->
    <v-app-bar app color="primary">
      <!--            <v-toolbar-side-icon class="hidden-md-and-up" @click="drawer = !drawer"></v-toolbar-side-icon>-->
      <span v-if="showBackArrow">
        <v-btn text :color="iconColor" icon @click="goBack()"><v-icon :color="iconColor">{{ icons.mdiArrowLeft }}</v-icon></v-btn>
      </span>
      <router-link v-if="!hideLogo" to="/" class="home-btn">
        <v-toolbar-title data-cy="titleBtn">
          <img :src="clientLogo" v-if="clientLogo" alt="" />
          <span v-else>{{appTitle}}</span>
        </v-toolbar-title>
      </router-link>
      <v-spacer></v-spacer>
      <span v-if="homeURL"><v-btn class="mr-1" text :color="iconColor" icon :href="homeURL" target="_blank"><v-icon dark>{{ icons.mdiHome }}</v-icon></v-btn></span>
      <!-- <v-btn class="mr-1" icon @click="toggleLanguage()" color="white" v-if="IS_DEV">
        <span v-if="$root.$i18n.locale.toLowerCase() === 'de'">EN</span>
        <span v-else>DE</span>
      </v-btn> -->

      <div v-if="!isAuthenticated && !is_sign_in && !is_web_view_disabled">
        <v-btn :color="iconColor" text to="/sign-in" data-cy="signinBtn" class="ignore-primary">{{ $t('auth.login') }}</v-btn>
      </div>
      <div v-else-if="isAuthenticated">
        <v-btn class="account-icon" text :color="iconColor" icon to="/account">
          <icon
            default-icon-name="mdiAccount"
            :custom-icon="customAccountIcon"
            :size="24"
            :color="iconColor"
            :label="$t('account.headline')"
            role="img"
          />
        </v-btn>
      </div>
    </v-app-bar>
  </div>
</template>


<script>
  import _ from 'lodash';
  import {IS_DEV} from '../store';
  import {localize} from 'vee-validate';
  import {mdiAccount, mdiLogout, mdiHome, mdiArrowLeft} from '@mdi/js';
  import {mapGetters} from 'vuex';
  import Icon from '@/components/ui/Icon';

  export default {
    name: "AppNavigation",
    data() {
      return {
        drawer: false,
        IS_DEV: IS_DEV,
        showBackArrow: false,
        items: [
          {title: 'Menu'},
          {title: 'Profile'},
          {title: 'Sign In'},
          {title: 'Join'}
        ],
        icons: {
          mdiAccount, mdiLogout, mdiHome, mdiArrowLeft
        }
      };
    },
    components: {Icon},
    computed: {
      ...mapGetters(['user']),
      isAuthenticated() {
        return this.$store.getters.isAuthenticated;
      },
      appTitle() {
        return _.get(this.$store.state, 'client.name');
      },
      clientLogo() {
        return _.get(this.$store.getters.extensionSettings, 'webview.navbar_logo');
      },
      hideLogo() {
        return _.get(this.$store.getters.extensionSettings, 'webview.hide_navbar_logo', false);
      },
      iconColor() {
        return _.get(this.$store.getters.extensionSettings, 'webview.theme.navigation_bar.icon_color');
      },
      homeURL() {
        return _.get(this.$store.getters.extensionSettings, 'webview.header.home');
      },
      is_sign_in() {
        return _.get(this.$route, 'name', '') === 'signin'
      },
      // check if the web view is disabled
      is_web_view_disabled() {
        return _.get(this.$store.getters.extensionSettings, 'webview.disabled_web_app', false)
      },
      customAccountIcon() {
        return _.get(this.$store.getters.extensionSettings, 'app-assets.icons.user_profile');
      }
    },
    methods: {
      logout() {
        this.$store.dispatch('userSignOut');
      },
      toggleLanguage() {
        let lng = 'de';
        if (this.$root.$i18n.locale.toLowerCase() === 'de') {
          lng = 'en';
        }
        this.$root.$i18n.locale = lng;
        localize(lng);
      },
      goBack() {
        this.$router.go(-1)
      }
    },
    watch: {
      $route(to) {
        if (
          to.name === 'home'
            || to.name === 'signin'
            || to.name === 'wallet-pass'
            || to.path === '/'
        ) {
          this.showBackArrow = false;
        } else {
          this.showBackArrow = true;
        }
      }
    }
  }
</script>

<style scoped lang="scss">
  a {
    color: white;
    text-decoration: none;
  }
  span.desktop {
    display: none;
  }
  .home-btn {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    height: 100%;
    .v-toolbar__title {
      height: 100%;
      display: flex;
      align-items: center;
    }
    img {
      height: 35px;
      width: auto;
      object-fit: contain;
    }
  }
  .account-icon {
    padding: 8px;
  }
  @media(max-width: 450px) {
    .v-btn:not(.v-btn--round).v-size--default {
      padding: 0 10px;
      min-width: auto;
    }
  }
  @media(min-width: 450px) {
    span.mobile {
      display: none;
    }
    span.desktop {
      display: block;
    }
  }
  .theme--light.v-app-bar.v-toolbar.v-sheet {
    color: var(--main-bar-header-text-color, #fff);
    background: var(--main-bar-header-background, var(--bar-headers-background));
    z-index: 100;

    a {
      color: inherit !important;
    }
  }
</style>
